export default {
  setAll (state, payload) {
    state.all = payload
  },
  setCategories (state, payload) {
    state.categories = payload
  }
}
